import React from 'react';

import classNames from './EABD2CaseTabContentContainer.module.scss';

export const CaseTabContentContainer = React.memo((props) => {
  const { children } = props;

  return <div className={classNames.root}>{children}</div>;
});
